import { Box, Button, FormLabel, IconButton, Modal } from '@mui/material';
import React from 'react';
import { CSVLink } from 'react-csv';
import Iconify from '../../iconify/Iconify';
import '../../../css/style.css';

function Newdynamicuser(props) {
  const { handeldynamicok, dynamicmodel, handledynamicClose, name, typeError, handleFile, Filename } = props;

  const header = [
    {
      UserId: 'NfIHnFUa0daZb7Zg5GUH',
      EmployerId: 'vsqQCNjEEU',
      LOPDays: '0',
      YearEndSettlement: '0',
      Notice: '0',
      Probation: '0',
      TemporaryDeactivation: '0',
      WithdrawalFactor: '0.7',
      MinAmtValue: '10',
      EmployeeOutStanding: '1',
      LastDateofEmployement: '2023/01/31',
    },
  ];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 2,
  };

  return (
    <>
      {/* New Users */}

      <Modal
        open={dynamicmodel}
        onClose={handledynamicClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div style={{ fontSize: '18px', fontWeight: '700' }}>Upload {name} file</div>
            <IconButton size="small" color="inherit" onClick={handledynamicClose}>
              <Iconify icon={'material-symbols:close'} />
            </IconButton>
          </div>
          <Button style={{ marginTop: '20px' }} variant="contained">
            <CSVLink style={{ color: 'white', textDecoration: 'none' }} data={header} filename="User.csv" target="">
              Download Sample
            </CSVLink>
          </Button>
          <div style={{ marginTop: '10px' }}>
            <form>
              <FormLabel className="file-input__label" htmlFor="file-input">
                <Iconify icon={'material-symbols:upload-sharp'} />
                <Box>Upload File</Box>
                <Box sx={{ fontSize: '14px' }}>{Filename}</Box>
              </FormLabel>
              <input type="file" id="file-input" className="file-input__input" required onChange={handleFile} />
            </form>
            {typeError && (
              <div style={{ color: 'red' }} className="alert alert-danger" role="alert">
                {typeError}
              </div>
            )}
          </div>
          <Button onClick={handeldynamicok} style={{ marginTop: '10px', width: '100%' }} variant="contained">
            UPLOAD
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default Newdynamicuser;
